import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Carousel } from "@gemini/ui";
import { useRefsContext } from "@/contexts/ref";
import { useModal, useTrackingLinkClick } from "@/hooks";
import { Section, Title } from "@/components/UI";
import { useRichMedias, MediaModal, MediaPreview, } from "@/components/Sections/RichMedias";
import { ModalIds } from "@/constants";
import { useClassified } from "@/contexts/classified";
import { embedBuilders, getProviderName, ProviderName, } from "./Media/mediaProviders";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const RichMedias = () => {
    var _a, _b;
    const { t } = useI18n();
    const { display, medias } = useRichMedias();
    const { richMediasRef } = useRefsContext();
    const [selectedMedia, setSelectedMedia] = useState();
    const [consentNeeded, setConsentNeeded] = useState(true);
    const { isOpen, toggle } = useModal(false, ModalIds.MEDIA);
    const { bWindow } = useBrowserAPI();
    const { av_distribution_type_global } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const handleTrackingLinkClick = useTrackingLinkClick({
        event: "outlink",
        data: {
            av_zone: "rich_media_section",
            av_distribution_type_global,
            av_pagetitle: "classified_detail",
            outbound: true,
        },
    });
    // default medias selected to open the modal directly
    useEffect(() => {
        var _a;
        if (!medias[0])
            return;
        const provider = getProviderName(medias[0].url);
        const canEmbed = !!((_a = embedBuilders[provider]) === null || _a === void 0 ? void 0 : _a.call(embedBuilders, medias[0].url));
        if (canEmbed)
            setSelectedMedia(medias[0]);
    }, [medias]);
    const hasOneMedia = (medias === null || medias === void 0 ? void 0 : medias.length) === 1;
    const onSelectMedia = (media) => {
        var _a;
        const provider = getProviderName(media.url);
        const canEmbed = !!((_a = embedBuilders[provider]) === null || _a === void 0 ? void 0 : _a.call(embedBuilders, media.url));
        setConsentNeeded(provider !== ProviderName.YOUTUBE);
        if (canEmbed) {
            setSelectedMedia(media);
            toggle();
        }
        else {
            bWindow.open(media.url);
            handleTrackingLinkClick({
                additionalProps: {
                    link_url: media.url,
                    link_text: "3D Tour",
                },
            });
        }
    };
    if (!display)
        return null;
    return (_jsxs(Section, { ref: richMediasRef, id: "richMedia", hasPaddingRight: hasOneMedia, unsafeClassname: "HideOnPrint", children: [_jsx(Title, { variant: "section", title: t("richMedia.title_v2"), hasMargin: false }), _jsx(Box, { display: "flex", overflow: ["hidden", "clip"], paddingRight: {
                    "breakpoint.base": hasOneMedia ? "spacing.none" : "spacing.32",
                    "breakpoint.lg": "spacing.4",
                }, justifyContent: hasOneMedia ? "center" : "flex-start", children: _jsx(Carousel, { itemsPerView: {
                        "breakpoint.base": 1,
                        "breakpoint.sm": 2,
                        "breakpoint.md": 2,
                        "breakpoint.lg": 2,
                        "breakpoint.xl": 3,
                        "breakpoint.xxl": 3,
                        "breakpoint.xxxl": 3,
                    }, arrowPosition: "outside", items: medias === null || medias === void 0 ? void 0 : medias.map((media) => ({
                        id: media.key,
                        item: (_jsx(MediaPreview, { media: media, onSelectMedia: onSelectMedia, BoxProps: {
                                maxWidth: {
                                    "breakpoint.sm": hasOneMedia ? "300px" : "inherit",
                                },
                            } }, media.key)),
                    })) }) }), selectedMedia && (_jsx(MediaModal, { consentNeeded: consentNeeded, media: selectedMedia, isOpen: isOpen, toggle: toggle }))] }));
};
